import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import style from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import GlobalButton from '../../../utility/globalButton/button';
import { EcomProduct } from '../../../../models/axiosModel';
import { filterProductInterface } from './product';
import { useProductStore } from '../../../../store/productStore';

interface ProductFilterPopupProps {
    setFlagFilterPopup: React.Dispatch<React.SetStateAction<boolean>>, 
    filters: filterProductInterface, 
    setFilters: React.Dispatch<React.SetStateAction<filterProductInterface>>,
} 

const ProductFilterPopup: React.FC<ProductFilterPopupProps> = (props) => {

    const { setFlagFilterPopup, filters, setFilters } = props; 
    const eComProductData = useProductStore((state) => state.eComProductData);  

    const [filtersInPopup, setFiltersInPopup] = useState<filterProductInterface>(filters);

    return (
        <>  
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}> Product Filter</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} /> 

                        <Grid item xs={12}>
                            <Grid container className={style.filterPopupBodyContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Product Name</Typography>
                                        </Grid> 
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                options={eComProductData ?? []}
                                                getOptionLabel={(option: EcomProduct) => option.ecom_product_name}
                                                multiple
                                                value={filtersInPopup.product_name ?? []}
                                                onChange={(_: React.SyntheticEvent, value: EcomProduct[]) => {
                                                    setFiltersInPopup((prevState: filterProductInterface) => ({ ...prevState, product_name: value }))
                                                }}
                                                renderInput={params => {
                                                    const { InputProps, ...restParams } = params;
                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                    return (
                                                        <TextField
                                                            {...restParams}
                                                            placeholder='Search by Product Name'
                                                            InputProps={{
                                                                ...restInputProps,
                                                                startAdornment: (
                                                                    <div style={{
                                                                        maxHeight: "79px",
                                                                        overflowY: 'auto',
                                                                    }}
                                                                    >
                                                                        {startAdornment}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => { setFlagFilterPopup(false); }}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Apply Filter"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        onClick={() => { 
                                            setFlagFilterPopup(false);
                                            setFilters(filtersInPopup);
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProductFilterPopup

